import React from 'react';
import FormatColorFillIcon from '@mui/icons-material/FormatColorFill';
import { ColorField, Group, NumberField, Section, SwatchGrid } from '../controls';
import { lastPaint, NEEDS_PAINT } from '../nodeProps';
import styles from './sections.module.css';

// Neutrals, then soft pastels; any other colour comes from the picker or a typed hex.
const FILL_SWATCHES = [
    '#ffffff', '#f3f4f6', '#9ca3af', '#1f2937', '#fecaca',
    '#fed7aa', '#fde68a', '#bbf7d0', '#a5f3fc', '#bfdbfe', '#ddd6fe',
];
const MIN_OPACITY = 0;
const MAX_OPACITY = 100;

/**
 * The shape's fill: swatches (the first is "no fill", D-035), then the colour as swatch + hex beside its opacity.
 * Opacity is saved inside nodeBg as rgba(), so the saved node keeps its shape.
 */
const FillSection = ({ values, change, mapColors }) => {
    const isNoneLocked = lastPaint(values) === 'fill';
    const chooseSwatch = (color) => change(color ? { isFilled: true, fill: color } : { isFilled: false });
    return (
        <Section id="fill" icon={<FormatColorFillIcon />} title="Fill">
            <Group
                label="Color"
                action={<span className={styles.groupValue}>{values.isFilled ? values.fill.toUpperCase() : 'None'}</span>}
            >
                <div className={styles.fillBody}>
                    <SwatchGrid
                        label="Fill swatches"
                        colors={FILL_SWATCHES}
                        value={values.isFilled ? values.fill : null}
                        none={{ label: 'No fill', lockedReason: isNoneLocked ? NEEDS_PAINT : undefined }}
                        onChange={chooseSwatch}
                    />
                    <div className={styles.colorOpacityRow}>
                        <ColorField
                            label="Fill color"
                            color={values.fill}
                            mapColors={mapColors}
                            disabled={!values.isFilled}
                            onChange={(fill) => change({ fill })}
                        />
                        <NumberField
                            title="Fill opacity"
                            unit="%"
                            min={MIN_OPACITY}
                            max={MAX_OPACITY}
                            value={values.fillAlpha}
                            disabled={!values.isFilled}
                            onChange={(fillAlpha) => change({ fillAlpha })}
                        />
                    </div>
                </div>
            </Group>
        </Section>
    );
};

export default FillSection;
